import EmployeeLayout from '@/components/EmployeeLayout/index.vue'

const employeeRoutes = [
  // 工资条详情页：独立布局（无顶部导航条），仅展示工资条预览
  {
    path: '/employee/salary-slip',
    name: 'EmployeeSalarySlip',
    component: () => import('@/views/employee/SalarySlip/index.vue'),
    meta: { title: '工资条', role: 'employee' }
  },
  {
    path: '/employee',
    component: EmployeeLayout,
    redirect: '/employee/dashboard',
    meta: { role: 'employee' },
    children: [
      {
        path: 'dashboard',
        name: 'EmployeeDashboard',
        component: () => import('@/views/employee/Dashboard/index.vue'),
        meta: { title: '工作台' }
      },
      {
        path: 'my-salary',
        name: 'MySalary',
        component: () => import('@/views/employee/MySalary/index.vue'),
        meta: { title: '我的工资' }
      },
      {
        path: 'feedback',
        name: 'EmployeeFeedback',
        component: () => import('@/views/employee/Feedback/index.vue'),
        meta: { title: '问题反馈' }
      },
      {
        path: 'my-requests',
        name: 'MyRequests',
        component: () => import('@/views/employee/MyRequests/index.vue'),
        meta: { title: '我的申请' }
      },
      {
        path: 'my-approvals',
        name: 'MyApprovals',
        component: () => import('@/views/employee/MyApprovals/index.vue'),
        meta: { title: '我的待办' }
      },
      {
        path: 'team-appraisal',
        name: 'TeamAppraisal',
        component: () => import('@/views/employee/TeamAppraisal/index.vue'),
        meta: { title: '下属考核' }
      },
      {
        path: 'my-appraisal',
        name: 'MyAppraisal',
        component: () => import('@/views/employee/MyAppraisal/index.vue'),
        meta: { title: '我的考核' }
      },
      {
        path: 'profile',
        name: 'EmployeeProfile',
        component: () => import('@/views/employee/Profile/index.vue'),
        meta: { title: '个人信息' }
      }
    ]
  }
]

export default employeeRoutes